import { Pipe, PipeTransform } from '@angular/core';
import { formatInTimeZone } from 'date-fns-tz';

@Pipe({
  name: 'ukTime',
})
export class UKTimePipe implements PipeTransform {
  transform(value: Date | number): string {
    return formatInTimeZone(value, 'Europe/London', 'yyyy-MM-dd HH:mm:ss');
  }

  transformWithFormat(value: Date | string | number, format: string): string {
    return formatInTimeZone(value, 'Europe/London', format);
  }
}
